import React from 'react';
import { reportActions } from 'actions/ReportActions';
import { reportStore } from 'stores/ReportStore';

export class LoadTimeoutPopup extends React.Component {
  constructor(props) {
    super(props);
    reportStore.listen(this.storeUpdated.bind(this));
    this.state = reportStore.getState();
  }

  storeUpdated() {
    this.setState(reportStore.getState());
  }

  componentDidUpdate() {
    this.state = this.props;
  }

  closeLoadTimeoutPopup() {
    reportActions.closeLoadTimeoutPopup();
  }

  render() {
    return (
      <div className={`details-popup-wrapper ${this.state.loadTimeoutPopupVisible ? '' : 'hidden'}`}>
        <div id={'detailsPopup'} className={'details-popup'}>
          <div className='popup-header blue darken-3'>
            <span>ASCE HAZARD TOOL</span>
            <span className='details-popup-close-icon' onClick={this.closeLoadTimeoutPopup}></span>
          </div>
          <div className='padding popup-body'>
            Due to high traffic or connectivity issues at the source website, some data failed to download. You can
            continue to build your report without the hazard, or try your query again at another time.
          </div>
          <div className={'fill_wide padding__long white popup-ok-button'}>
            <a
              className={'waves-effect waves-light btn-large blue darken-4 fill__wide '}
              onClick={this.closeLoadTimeoutPopup}
            >
              OK
            </a>
          </div>
        </div>
      </div>
    );
  }
}
